export const typeCoverPicture = '4'
export const typeMessageAttatchments = '7'